import { observer } from 'mobx-react';
import { useStores } from 'stores';
import { Select } from 'uiKit/atoms/Select/Select';
import { MenuItem } from 'uiKit/atoms/MenuItem/MenuItem';
import { FormControl } from 'uiKit/atoms/FormControl/FormControl';
import { ReactComponent as ExpandMoreSvg } from '../../../../assets/img/expand-more.svg';
import { lotsPerPageArr } from '../../../../constants';
import styles from './LotsPerPage.module.scss';

const LotsPerPage = ({ onFilterChange }) => {
  const { lotStore } = useStores();
  const { itemsPerPage } = lotStore.filters;

  const handleLotsPerPageChange = event => {
    const value = event.target.value;
    lotStore.updateCurrentPage(1);
    onFilterChange([{ name: 'pageNumber', pageNumber: 1 }]);
    onFilterChange([{ name: 'itemsPerPage', value }]);
  };

  return (
    <div className={styles.bns3_per_page_select_wrapper}>
      <FormControl>
        <Select
          sx={{
            minWidth: 100,
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: '30px',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#28b8e0;',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#28b8e0;',
            },
          }}
          className={styles.bns3_dropdown_option}
          value={itemsPerPage}
          onChange={handleLotsPerPageChange}
          displayEmpty
          IconComponent={ExpandMoreSvg}
        >
          {lotsPerPageArr.map(num => (
            <MenuItem key={`lotsPerPage${num}`} value={num}>
              {`Lots per page: ${num} lots`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default observer(LotsPerPage);
